import { NgModule, Pipe, PipeTransform } from '@angular/core';
import { isPresent } from '@mtna/core-ts';
import { Variable } from '@mtna/pojo-consumer-ts';
import { VariableSummary } from '@mtna/variable-service-core-ts';

@Pipe({
  name: 'rdsVariableDisplay',
})
export class RdsGetVariableDisplayPipe implements PipeTransform {
  /**
   *
   * @param variable Variable or VariableSummary
   * @param props keys of Variable to attempt to return instead of default label, name, or id
   */
  transform<V extends Variable | VariableSummary>(variable: V | undefined | null, ...props: Array<string & keyof V>): string {
    if (!variable) {
      return '';
    }
    if (props?.length) {
      for (const prop of props) {
        if (isPresent(variable[prop])) {
          return `${variable[prop]}`;
        }
      }
    }
    return variable.label || variable.name || variable.id || '';
  }
}

@NgModule({
  exports: [RdsGetVariableDisplayPipe],
  declarations: [RdsGetVariableDisplayPipe],
})
export class RdsGetVariableDisplayPipeModule {}
